import { lookAtThatApi, type LookAtThatExploreItem } from '../../lib/lookAtThatApi';

export function ExploreGallery({
  runId,
  items,
}: {
  runId: string;
  items: LookAtThatExploreItem[];
}) {
  if (items.length === 0) {
    return (
      <div className="card">
        <h3 style={{ margin: '0 0 8px' }}>Explore gallery</h3>
        <p className="muted small" style={{ margin: 0 }}>
          Use Explore with a prompt (paytable, max win, RG text, …). Captures land here with a short explanation.
        </p>
      </div>
    );
  }
  return (
    <div className="card">
      <h3 style={{ margin: '0 0 8px' }}>Explore gallery</h3>
      <div className="look-at-that-gallery">
        {items.map((item) => (
          <figure key={item.id} className="look-at-that-gallery-item">
            <img src={lookAtThatApi.exploreImageUrl(runId, item.file)} alt={item.prompt} />
            <figcaption>
              <strong>{item.prompt}</strong>
              <p className="small" style={{ margin: '4px 0 0' }}>
                {item.explanation}
              </p>
              <span className="muted small">{new Date(item.ts).toLocaleString()}</span>
            </figcaption>
          </figure>
        ))}
      </div>
    </div>
  );
}
